module.exports = __webpack_public_path__ + "img/pdf.63c1cf13.svg";